import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import ConfirmationModal from '../../../common/modal/ConfirmationModal';
import { deleteDetraction } from '../../../../actions';

const DetractionDeleteButton = ({
  dispatchDeleteDetraction,
  detractionId,
  disabled,
}) => {
  const [showModal, setShowModal] = useState(false);

  const onClickDelete = () => dispatchDeleteDetraction({ detractionId });

  const openModal = () => setShowModal(true);

  const closeModal = () => setShowModal(false);

  return (
    <>
      <ConfirmationModal
        show={showModal}
        onClickConfirm={onClickDelete}
        onClickCancel={closeModal}
      />
      <Button color="danger" onClick={openModal} disabled={disabled}>
        <i className="fa fa-trash-o" /> Eliminar
      </Button>
    </>
  );
};

DetractionDeleteButton.propTypes = {
  dispatchDeleteDetraction: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  detractionId: PropTypes.number.isRequired,
};

DetractionDeleteButton.defaultProps = {
  disabled: false,
};

const mapDispatchToProps = {
  dispatchDeleteDetraction: deleteDetraction,
};

export default connect(null, mapDispatchToProps)(DetractionDeleteButton);
